module.exports = __webpack_public_path__ + "img/tabs_b_active.70e8ef6a.png";